<template>
  <Loading :loading="loading" class="orders row">
    <h2 class="col-12">Refer a Friend</h2>
    <div class="col-12 col-md-8">
      <p>Enter your friend's email address to refer them to Cherrytree. Their details will automatically
be recorded here once you hit send. You will receive a notification email if they join up.</p>
      <ReferFriend />
      <p>
      Share this link with a friend to refer them to Cherrytree.
        <Popup>
          <input
            v-model="signupLink"
            id="signupLink"
            readonly
            style="width:400px"
            class="js-copytextarea form-control"
            @click="copyReferralLink"
          >
          <span :class="{'valid': copied, 'popup': true}">
            Copied to clipboard
          </span>
        </Popup>
      </p>
      <div v-if="referrals.length === 0">
        <hr/>
        <div>
          <p>You haven't referred anyone yet.</p>
          <p>Share your code with a friend.</p>
          <p>Referrals will show up when they sign up and verify their email addresses</p>
        </div>
      </div>
      <div v-else>
        <h2>Referrals</h2>
        <table class="table">
          <tr>
            <th>Name</th>
            <th>Join Date</th>
            <th>Status</th>
          </tr>
        <tr v-for="referral in referrals" :key="referral.id">
          <td>{{referral.given_name}} {{referral.family_name}}</td>
          <td>{{referral.date_joined.split(" ")[0]}}</td>
          <td>{{referral.membership_type}}</td>
        </tr>
        </table>
      </div>
    </div>
  </Loading>
</template>

<script>
import { fetchUserReferrals } from "@/network/userRequests";
import Loading from "@/components/loading/Loading";
import Popup from "@/wordpress/components/Popup"
import ReferFriend from './ReferFriend'

export default {
  name: "MyReferrals",
  components: {
    Loading,
    Popup,
    ReferFriend
  },
  data() {
    return {
      referrals: [],
      referralCode: "",
      loading: false,
      copied: false
    };
  },
  created() {
    this.loading = true;
    fetchUserReferrals(({ referrals, referral_code }) => {
      this.referrals = referrals; //array of user's referrals
      this.referralCode = referral_code; //user's referral code
      this.loading = false;
    });
  },
  computed: {
    //compute signup link by taking path to signup page and current base url
    signupLink() {
      let path = this.$router.resolve({
        name: "signup",
        query: { referral: this.referralCode }
      }).href;
      let fullUrl = window.location.origin + path;
      return fullUrl;
    }
  },
  methods: {
    //copy referral link to clipboard
    copyReferralLink() {
      let linkField = document.querySelector("#signupLink");
      linkField.select();

      try {
        let successful = document.execCommand("copy");
        if (successful) {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        }
      } catch {
        // console.log("couldn't copy");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.referralCode {
  font-size: 2em;
}
#signupLink{
  cursor: pointer;
}

@include media-breakpoint-down(sm){
  .js-copytextarea{
    max-width: 100%;
  }
}
</style>
